import styled from "../../styled-components";
import { Stack } from "../Stack";

export const Container = styled(Stack)`
  width: 100%;
  max-width: ${props => props.theme.breakpoints._452};
  margin-left: auto;
  margin-right: auto;
`;
